// Copyright 2019, White Label Communications, LLC, All rights reserved.

import {
  FETCH_LOGOUT_SUCCESS,
} from 'actions/LoginActions';
import {
  FETCH_DEFAULT_CHANNELS_SUCCESS,
  DEFAULT_CHANNELS_POST_SUCCESS,
} from 'actions/DefaultChannelsActions';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_DEFAULT_CHANNELS_SUCCESS:
    case DEFAULT_CHANNELS_POST_SUCCESS:
      // console.log('FETCH_DEFAULT_CHANNELS_SUCCESS: ', action); // eslint-disable-line no-console
      return action.data; // this value passed in on action
    case FETCH_LOGOUT_SUCCESS:
      return {};
    default:
      return state;
  }
}
